import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Page } from 'shared/ui/Page';
import { SubscriptionCard } from 'features/subscriptions/components';

import {
    SubscriptionProps,
    SubscriptionSlug,
} from '../../interfaces/subscription.interface';
import { useProfileData } from '../../../../hooks/useProfileData';
import { SuccessModal } from '../../components/Success';
import { useToggle } from '../../../../hooks/useToggle';

export const Subscriptions: React.FC = () => {
    const { subscriptions, isLoadingSubscription } = useProfileData();

    const [subscription, setSubscription] = useState<SubscriptionProps>(null);
    const { open, setOpen } = useToggle(false);

    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (!isLoadingSubscription && subscriptions) {
            const paidSubscription = subscriptions.find(
                elem => elem.slug === SubscriptionSlug.payJuriPlan
            );
            setSubscription(paidSubscription);
        }
    }, [isLoadingSubscription, subscriptions]);

    useEffect(() => {
        if (searchParams) {
            const paid = +searchParams.get('paid') === 1;
            if (paid) {
                return setOpen(true);
            }
        }
    }, [searchParams]);

    return (
        <Page title='Подписка'>
            <SuccessModal open={open} setOpen={setOpen} />
            <SubscriptionCard {...subscription} />
        </Page>
    );
};
